/* eslint-disable */
$(function () {
  if ($('.country-code-select').length) {
    $('.country-code-select').select2({
      width: '100%',
    });
  }

  if ($('.datepicker').length) {
    $('.datepicker .mod-input').flatpickr({
      enableTime: true,
      disableMobile: 'true',
      minDate: 'today',
      dateFormat: 'Y-m-d H:i',
    });
  }
});
/* eslint-enable */
